var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-box"},[_c('div',{staticClass:"loading-box-inner"},[_c('div',{staticClass:"loader-in"},[_c('v-icon',[_vm._v("mdi mdi-loading mdi-spin")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }